(() => {
  const container = document.querySelector('[data-custom-home-review-deferred]');
  const mount = container?.querySelector('[data-custom-home-review-mount]');
  const template = container?.querySelector('[data-custom-home-review-template]');

  if (!container || !mount || !template) return;

  let activated = false;

  const reviveScripts = (root) => {
    root.querySelectorAll('script').forEach((original) => {
      const replacement = document.createElement('script');
      [...original.attributes].forEach(({ name, value }) => replacement.setAttribute(name, value));
      replacement.textContent = original.textContent;
      original.replaceWith(replacement);
    });
  };

  const loadEnhancement = () => {
    const src = container.dataset.enhancementSrc;
    if (!src || document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.append(script);
  };

  const loadJudgeLightbox = async () => {
    const widget = mount.querySelector('[data-entry-point][data-entry-key]');
    const entryPoint = widget?.dataset.entryPoint;
    const entryKey = widget?.dataset.entryKey;
    const baseUrl = window.jdgm?.CDN_BASE_URL;
    if (!entryPoint || !entryKey || !baseUrl || window.jdgmCarouselLightbox?.open) return;

    const src = `${baseUrl}${entryPoint}`;
    if (document.querySelector(`script[src="${src}"]`)) return;

    try {
      const response = await fetch(`${baseUrl}manifest.json?v=${Date.now()}`);
      const manifest = await response.json();
      const visited = new Set();
      const cssFiles = new Set();

      const collectCss = (key) => {
        if (!key || visited.has(key)) return;
        visited.add(key);

        const entry = manifest[key];
        entry?.css?.forEach((file) => cssFiles.add(file));
        entry?.imports?.forEach(collectCss);
      };

      collectCss(entryKey);
      await Promise.all([...cssFiles].map((file) => new Promise((resolve) => {
        const href = `${baseUrl}${file}`;
        if (document.querySelector(`link[href="${href}"]`)) {
          resolve();
          return;
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.addEventListener('load', resolve, { once: true });
        link.addEventListener('error', resolve, { once: true });
        document.head.append(link);
      })));
    } catch (_error) {
      // The module can still initialize; Judge.me may provide its styles from cache.
    }

    const script = document.createElement('script');
    script.src = src;
    script.type = 'module';
    document.head.append(script);
  };

  const activate = () => {
    if (activated) return;
    activated = true;

    const content = template.content.cloneNode(true);
    mount.append(content);
    template.remove();
    reviveScripts(mount);
    loadJudgeLightbox();
    loadEnhancement();
    container.dataset.customHomeReviewReady = 'true';
  };

  if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
    activate();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      activate();
    },
    { rootMargin: '250% 0px' },
  );

  observer.observe(container);
})();
